import { createApi } from '@reduxjs/toolkit/query/react';
import { IMarket } from '../../shared/models/core/market';
import { MarketFilterSet } from '../../shared/models/core/market-filter-set';
import { IPagedResult } from '../../shared/models/paged-result';
import { serialize } from '../../utility/serialize';
import { baseQuery } from './baseQuery';

export const marketApi = createApi({
  reducerPath: 'marketApi',
  baseQuery,
  tagTypes: ['Markets'],
  endpoints: (builder) => ({
    getMarkets: builder.query<IPagedResult<IMarket>, MarketFilterSet | undefined>({
      query: (filter?) => {
        const params = filter ? serialize(filter) : 'size=1000';
        return {
          url: `/api/markets?${params}`,
          method: 'GET',
        };
      },
      providesTags: ['Markets'],
    }),
    getMarket: builder.query<IMarket, string>({
      query: (id) => ({
        url: `/api/markets/${id}`,
        method: 'GET',
      }),
      providesTags: (_result, _error, id) => [{ type: 'Markets', id }],
    }),
  }),
});

export const { useGetMarketsQuery, useGetMarketQuery } = marketApi;
